// Enables the "change plan" submit button only when a plan other than the
// current one is selected. The prorated cost breakdown and confirmation now
// live on Stripe's hosted page, which the form redirects to on submit.
function syncSubmitState(dialog: HTMLElement): void {
  const selectedPlan = dialog.querySelector(
    'input[name="subscription_plan"]:checked',
  ) as HTMLInputElement | null;
  const submitBtn = dialog.querySelector(".submit-new-plan") as HTMLButtonElement | null;

  if (!submitBtn) {
    return;
  }

  submitBtn.disabled = !selectedPlan || selectedPlan.hasAttribute("data-current-plan");
}

export const initChangePlan = () => {
  const dialog = document.getElementById("dialog-change-plan");

  if (!dialog) {
    return;
  }

  const planRadios = dialog.querySelectorAll(
    'input[name="subscription_plan"]',
  ) as NodeListOf<HTMLInputElement>;

  planRadios.forEach((radio) => {
    radio.addEventListener("change", () => syncSubmitState(dialog));
  });

  syncSubmitState(dialog);
};
